var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_785",
    "data-name": "Group 785",
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.049,
    height: 29.47,
    viewBox: "0 0 29.049 29.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_465",
    "data-name": "Path 465",
    d: "M3352.475,888.651h3.071a.293.293,0,0,0,0-.586h-3.071a.293.293,0,0,0,0,.586Z",
    transform: "translate(-3346.184 -876.832)",
    fill: "#084688"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_466",
    "data-name": "Path 466",
    d: "M3461.5,632.28a.293.293,0,0,0,.414-.414l-2.172-2.172a.293.293,0,0,0-.414.414Z",
    transform: "translate(-3449.954 -626.318)",
    fill: "#084688"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_467",
    "data-name": "Path 467",
    d: "M3717.993,526.2a.294.294,0,0,0,.293-.293V522.84a.293.293,0,0,0-.586,0v3.071A.293.293,0,0,0,3717.993,526.2Z",
    transform: "translate(-3700.469 -522.547)",
    fill: "#084688"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_468",
    "data-name": "Path 468",
    d: "M3905.764,632.366a.3.3,0,0,0,.207-.086l2.171-2.172a.293.293,0,0,0-.414-.414l-2.172,2.172a.293.293,0,0,0,0,.414A.3.3,0,0,0,3905.764,632.366Z",
    transform: "translate(-3882.469 -626.318)",
    fill: "#084688"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_469",
    "data-name": "Path 469",
    d: "M3905.972,1075.922a.294.294,0,0,0-.415.415l2.172,2.171a.292.292,0,0,0,.414,0,.293.293,0,0,0,0-.414Z",
    transform: "translate(-3882.469 -1058.833)",
    fill: "#084688"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_470",
    "data-name": "Path 470",
    d: "M3986.646,888.065h-3.07a.293.293,0,0,0,0,.586h3.07a.293.293,0,1,0,0-.586Z",
    transform: "translate(-3957.891 -876.832)",
    fill: "#084688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_471",
    "data-name": "Path 471",
    d: "M3708.929,1229.561l.825,7.742h7.858l-2.664-7.742Z",
    transform: "translate(-3691.968 -1207.833)",
    fill: "#084688"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_472",
    "data-name": "Path 472",
    d: "M3432.7,1229.561l-.825,7.742h8.751l-.825-7.742Z",
    transform: "translate(-3423.427 -1207.833)",
    fill: "#084688"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_473",
    "data-name": "Path 473",
    d: "M3159.678,1229.561l-2.665,7.742h7.858l.825-7.742Z",
    transform: "translate(-3157.013 -1207.833)",
    fill: "#084688"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_474",
    "data-name": "Path 474",
    d: "M3256.907,981.169H3252.7l-2.426,7.048h5.88Z",
    transform: "translate(-3247.409 -967.074)",
    fill: "#084688"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_475",
    "data-name": "Path 475",
    d: "M3463.066,981.168h-1.555l-.751,7.048h6.975l-.751-7.048Z",
    transform: "translate(-3451.426 -967.074)",
    fill: "#084688"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_476",
    "data-name": "Path 476",
    d: "M3689.091,988.216l-1.572-4.569-.01-.029-.843-2.449h-4.206l.752,7.048Z",
    transform: "translate(-3666.313 -967.074)",
    fill: "#084688"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_477",
    "data-name": "Path 477",
    d: "M3531,709.1h8.745a.292.292,0,0,1,.276.2l.778,2.261c.061-.056.12-.113.177-.171A6.041,6.041,0,1,0,3531,709.1Z",
    transform: "translate(-3519.185 -695.593)",
    fill: "#084688"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolar);
export default __webpack_public_path__ + "static/media/solar.6bc98513.svg";
export { ForwardRef as ReactComponent };